import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiSendRequestSupportEmail } from "../../services/EmailService";
import { apiGetAllProducts } from "../../services/ProductsService";
import { apiGetAllSampleCards } from "../../services/SampleCardsService";
import Button from "../common/Button";
import { DatePicker } from "../common/DatePicker";
import { SelectBox } from "../common/SelectBox";
import { TextArea } from "../common/TextArea";
import { TextBox } from "../common/TextBox";
import { TextBoxEmail } from "../common/TextBoxEmail";
import { useSelector } from "react-redux";

interface Props {
    onRequestSent?: any;
}

const translationPrefix = 'Support';

const RequestForColor = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });

    const userInfo = useSelector((state: any) => state.userInfo);

    const [loadingProducts, setLoadingProducts] = useState(true);
    const [loadingSampleCards, setLoadingSampleCards] = useState(true);
    const [formData, setFormData] = useState({
        product: null,
        sampleCard: null,
        color: '',
        email: userInfo.Email,
        name: userInfo.FullName,
        phone: userInfo.Phone,
        dueDate: undefined,
        comment: ''
    });
debugger;
    const [products, setProducts] = useState([]);
    const [sampleCards, setSampleCards] = useState([]);

    useEffect(() => {
        apiGetAllProducts(false).then(
            (responseData) => {
                if (responseData && responseData.data) {
                    let arr = responseData.data.map((element) => {
                        element.value = element.id;
                        element.label = element.name;
                        return element;
                    });
                    setProducts(arr);
                }
            }
        ).finally(() => {
            setLoadingProducts(false);
        });
        apiGetAllSampleCards().then(
            (responseData) => {
                if (responseData && responseData.data) {
                    let arr = responseData.data.map((element) => {
                        element.value = element.id;
                        element.label = element.name;
                        return element;
                    });
                    setSampleCards(arr);
                }
            }
        ).finally(() => {
            setLoadingSampleCards(false);
        });
    }, []);

    const handleSendRequest = () => {
        const extProduct = products.find((p: any) => { return p.value === formData.product }) as any;
        const extSampleCard = sampleCards.find((p: any) => { return p.value === formData.sampleCard }) as any;
        if (extProduct) {
            formData.product = extProduct.label;
        }
        if (extSampleCard) {
            formData.sampleCard = extSampleCard.label;
        }
        apiSendRequestSupportEmail(formData).then((response) => {
            props.onRequestSent(true);
            setFormData({
                product: null,
                sampleCard: null,
                color: '',
                email: '',
                name: '',
                phone: '',
                dueDate: undefined,
                comment: ''
            });
        }).catch((err: any) => {
            props.onRequestSent(false, err);
        });
    }

    return (
        <>
            <SelectBox
                placeholder={t('ProductPlaceHolder')}
                isDisabled={false}
                options={products}
                label={t('Product')}
                formData={formData}
                setStateMethod={setFormData}
                dataField={'product'}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
                value={formData.product}
            />
            <SelectBox
                placeholder={t('SampleBookPlaceHolder')}
                isDisabled={false}
                options={sampleCards}
                label={t('SampleBook')}
                formData={formData}
                setStateMethod={setFormData}
                dataField={'sampleCard'}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
                value={formData.sampleCard}
            />
            <TextBox
                id="requiredColor"
                label={t('RequiredColor')}
                placeholder={t('RequiredColorPlaceHolder')}
                dataField="color"
                value={formData.color}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <TextBoxEmail
                id="email"
                label={t('Email')}
                placeholder={t('EmailPlaceHolder')}
                dataField="email"
                value={formData.email}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <TextBox
                id="name"
                label={t('Name')}
                placeholder={t('NamePlaceHolder')}
                dataField="name"
                value={formData.name}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <TextBox
                id="phone"
                label={t('Phone')}
                placeholder={t('PhonePlaceHolder')}
                dataField="phone"
                value={formData.phone}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <DatePicker
                id="dueDate"
                label={t('RequiredDate')}
                placeholder={t('RequiredDatePlaceHolder')}
                dataField="dueDate"
                value={formData.dueDate}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <TextArea
                id={'comment'}
                label={t('Note')}
                placeholder={t('NotePlaceHolder')}
                rows={4}
                dataField="comment"
                formData={formData}
                setStateMethod={setFormData}
                value={formData.comment}
                customColClassForLabel={'col-sm-2'}
                customColClassForValue={'col-sm-4'}
            />
            <Button
                text={t('Submit')}
                onClick={handleSendRequest}
                iconClass={'unset'}
            />
        </>
    );
}

export default RequestForColor;